import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage';
import type { UsersRouteParams } from '@openx/types/user';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context';
import { isAdmin } from '../../permissions/validators';
import { UserDetails } from './components/UserDetails/UserDetails';

export const UserDetailsPage = () => {
  const { session } = useAuth();
  const { userId = '' } = useParams<UsersRouteParams>();
  const navigate = useNavigate();
  const isAllowed = isAdmin(session);

  const handleGoBack = useCallback(() => {
    navigate('/users');
  }, [navigate]);

  if (!isAllowed) return <AccessForbiddenPage />;

  return <UserDetails handleGoBack={handleGoBack} userId={userId} titlePrefix={'OpenXSelect'} />;
};
